// extracted by mini-css-extract-plugin
module.exports = {"downloadButton":"DownloadTaxesButton_downloadButton__3Pw_s"};